/**
 * 图片和视频加解密 性能优化代码，主要是通过资源懒加载来实现
 *
 * 使用案例
 * 图片和视频
 * v-lazy="$cdnStatic('/qqc/static/images/video/qqc_az.mp4')"
 *
 * 背景图
 * v-lazy:background-image="$cdnStatic('/qqc/images/paly_img.png')"
 *
 * * 本插件默认认为，使用此方法代表要对图片进行解密操作。
 * * 图片和视频加密的方法请参考readme.md
 */

import Vue from "vue";
import VueLazyload from "vue-lazyload";
import url2Base64 from "../utils/url2Base64";

Vue.prototype.$cdnStatic = function(url) {
  return `https://yfeyf.com${url}`;
  // return `http://localhost:3000/${url}`;
};

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  adapter: {
    // 因为图片是加密过的，所以加载图片会走 error 方法
    error(listener) {
      let imgURL = listener.src; //获取图片地址

      if (!imgURL || imgURL.includes(";base64,")) return;
      url2Base64(imgURL).then((res) => {
        if (listener.bindType === "background-image") {
          listener.el.style.backgroundImage = "url(" + res + ")";
        } else {
          listener.el.setAttribute("src", res);
        }
      });
    },
  },
});

/**
 * video 的 src 和 poster 一起使用 lazy 有冲突，单独注册一个指令来解密 poster 图片
 */
Vue.directive("lazy-poster", {
  bind: async function(el, bing) {
    let imgURL = bing.value; //获取图片地址
    if (imgURL.includes(";base64,")) return;
    let res = await url2Base64(imgURL);
    el.setAttribute("poster", res);
  },
});
